import { Typography } from '@mui/material';
import { LelyDialog } from '@/common/components';

type Props = {
  open: boolean;
  onApplyClick: () => void;
  onCancelClick: () => void;
  onClose: () => void;
};

const ConfirmCloseDialog = ({
  open,
  onApplyClick,
  onCancelClick,
  onClose,
}: Props) => {
  return (
    <LelyDialog
      open={open}
      size="sm"
      title="Changes not applied"
      content={
        <Typography variant="xs">
          Your changes have not been applied yet. Apply them now to keep your
          changes, or cancel to discard them.
        </Typography>
      }
      leftActionButton="Cancel"
      leftActionHandler={onCancelClick}
      rightActionButton="Apply"
      rightActionHandler={onApplyClick}
      onClose={onClose}
    />
  );
};

export default ConfirmCloseDialog;
